module.exports = __webpack_public_path__ + "static/media/photo8.6d9e0b92.jpg";